var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tabbed-content" },
    [
      !_vm.isMobile
        ? _c(
            "div",
            { staticClass: "row title-bar no-gutters" },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c("div", { staticClass: "col-md" }, [
                _c("div", {
                  staticClass: "title-wrapper",
                  class: {
                    "left-radius": index === 0,
                    "right-radius": index === _vm.tabs.length - 1,
                    active: index === _vm.currentTabIndex,
                  },
                  domProps: { innerHTML: _vm._s(tab.title) },
                  on: {
                    click: function ($event) {
                      return _vm.setCurrentTabIndex(index)
                    },
                  },
                }),
              ])
            }),
            0
          )
        : _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.currentTabIndex,
                  expression: "currentTabIndex",
                },
              ],
              staticClass: "form-control mb-4",
              on: {
                change: [
                  function ($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function (o) {
                        return o.selected
                      })
                      .map(function (o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.currentTabIndex = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  },
                  _vm.setCurrentTab,
                ],
              },
            },
            _vm._l(_vm.tabs, function (tab, index) {
              return _c("option", { domProps: { value: index } }, [
                _vm._v("\n            " + _vm._s(tab.title) + "\n        "),
              ])
            }),
            0
          ),
      _vm._v(" "),
      _vm._l(_vm.tabs, function (tab, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: index === _vm.currentTabIndex,
                expression: "index === currentTabIndex",
              },
            ],
            staticClass: "row",
          },
          [
            _c("div", { staticClass: "col-md-5 ml-md-5 order-1 order-xl-0" }, [
              _c("div", {
                staticClass: "content",
                domProps: { innerHTML: _vm._s(tab.text) },
              }),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-6 order-0 order-xl-1 mb-5 mb-xl-0" },
              [
                _c("img", {
                  staticClass: "img img-fluid lozad mt-5 mt-xl-0",
                  attrs: {
                    "data-src": tab.image,
                    alt: tab.title,
                    "data-srcset": tab.imageSrcset,
                  },
                }),
              ]
            ),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }